export const environment = {
  production: true,
  defaultauth: "fackbackend",
  url: "https://backoffice.igbnetwork.digital/",
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },
  api: {
    apiDomain: "https://backendnetworkigb.onrender.com",
  },
};

//PRUEBA PARA REPOSITORIO